<script>
import ApiService from "../../Utils/axios";
export default {
  mounted() {
    document.title = "Ajouter un service - Auditor";
  },
  data() {
    return { institution: { name: "" } };
  },
  beforeMount() {
    const { institution_id } = this.$route.query;
    this.fetchInstitution(institution_id);
  },
  methods: {
    fetchInstitution(id) {
      new ApiService().get("/api/institution/" + id).then((res) => {
        this.institution = res.data.data;
      });
    },
    handleSubmit(e) {
      e.preventDefault();
      let body = {
        name: e.target[0].value,
        reference: e.target[1].value,
        description: e.target[2].value,
        institution_id: this.institution.id,
      };
      new ApiService()
        .post("/api/service", body)
        .then((res) => {
          this.$router.push("/" + this.$i18n.locale + "/institution");
          this.$store.dispatch("Alert/activate", {
            type: "success",
            text: "Service ajouté à " + this.institution.name + " avec succée",
          });
        })
        .catch((err) => {
          console.log(err);
          this.$router.push("/" + this.$i18n.locale + "/institution");
          this.$store.dispatch("Alert/activate", {
            type: "danger",
            text: "Une erreur est survenue, veuillez réessayer ultérieurement ou contacter l'administration.",
          });
        });
    },
  },
};
</script>

<template>
  <b-container fluid>
    <iq-card>
      <div class="iq-card-header d-flex justify-content-between">
        <div class="iq-header-title">
          <h4 class="card-title">
            Ajouter un service à
            <span class="text-primary">{{ institution.name }} </span>
          </h4>
        </div>
      </div>
      <form @submit="handleSubmit" class="iq-card-body">
        <div class="form-group row">
          <div class="col">
            <label>Nom</label>
            <input
              type="text"
              class="form-control"
              placeholder="Nom"
              required
            />
          </div>
          <div class="col">
            <label>Abreviation</label>
            <input
              type="text"
              class="form-control"
              placeholder="Abreviation"
              required
            />
          </div>
        </div>
        <div class="form-group">
          <label>Description</label>
          <textarea
            class="form-control"
            placeholder="Description"
            required
          ></textarea>
        </div>

        <button type="button" class="btn iq-bg-danger" @click="$router.back()">
          Annuler
        </button>
        <button type="submit" class="btn btn-primary mx-2">Enregistrer</button>
      </form>
    </iq-card>
  </b-container>
</template>
